// extracted by mini-css-extract-plugin
export var fadeIn = "_b5-0";
export var panelInner = "_b5-2";
export var panelOuter = "_b5-1";